function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

var adsFree = 'adsFree';
var amexCard = 'amexCard';
var american_express = 'american_express';
var appleGenerativeAward = 'appleGenerativeAward';
var attention = 'attention';
var appStoreBadge = 'appStoreBadge';
var backLeft = 'backLeft';
var basicBlack = 'basicBlack';
var bit1Cube = 'bit1Cube';
var basicGrey = 'basicGrey';
var bitBordered = 'bitBordered';
var bit3Cubes = 'bit3Cubes';
var angular = 'angular';
var bitCube = 'bitCube';
var boostEfficiency = 'boostEfficiency';
var boyAndGirl = 'boyAndGirl';
var bitBought = 'bitBought';
var boyAndGirlV2 = 'boyAndGirlV2';
var boyEatsCookie = 'boyEatsCookie';
var c = 'c';
var brokenHeart = 'brokenHeart';
var cSharp2 = 'cSharp2';
var calendarV2 = 'calendarV2';
var certificateV1Incomplete = 'certificateV1Incomplete';
var certificateV2Incomplete = 'certificateV2Incomplete';
var circleDownGrey = 'circleDownGrey';
var certificateV2Complete = 'certificateV2Complete';
var correctRoundBlue = 'correctRoundBlue';
var certificateV1Complete = 'certificateV1Complete';
var connectedAccountAvatar = 'connectedAccountAvatar';
var bit = 'bit';
var cpp = 'cpp';
var cplusplus = 'cplusplus';
var csharp = 'csharp';
var codeCheck = 'codeCheck';
var diagram = 'diagram';
var boyBoyGirl = 'boyBoyGirl';
var dsPython = 'dsPython';
var crossPlatform = 'crossPlatform';
var earnXp = 'earnXp';
var css = 'css';
var edTech = 'edTech';
var educationalBlueBoxer = 'educationalBlueBoxer';
var educationalBlue = 'educationalBlue';
var energeticMagenta = 'energeticMagenta';
var discoverCard = 'discoverCard';
var eom = 'eom';
var discover = 'discover';
var boyWithLaptop = 'boyWithLaptop';
var elo = 'elo';
var fbCircle = 'fbCircle';
var envelopIllustration = 'envelopIllustration';
var flagOrange = 'flagOrange';
var errorIllustration = 'errorIllustration';
var girlWithLaptopV2 = 'girlWithLaptopV2';
var fire = 'fire';
var github = 'github';
var flag = 'flag';
var growingGreenHero = 'growingGreenHero';
var girlWithLaptop = 'girlWithLaptop';
var help = 'help';
var html = 'html';
var infiniteHearts = 'infiniteHearts';
var infinityV3 = 'infinityV3';
var infinityV4 = 'infinityV4';
var infinityV2 = 'infinityV2';
var infinity = 'infinity';
var info = 'info';
var instagramPrimary = 'instagramPrimary';
var intergalactic = 'intergalactic';
var innovativePurple = 'innovativePurple';
var innovativePurplePuzzle = 'innovativePurplePuzzle';
var java = 'java';
var jquery = 'jquery';
var js = 'js';
var jcb = 'jcb';
var growingGreen = 'growingGreen';
var jcbCard = 'jcbCard';
var leaderboardOnboarding = 'leaderboardOnboarding';
var kotlin = 'kotlin';
var linkedin = 'linkedin';
var logOut = 'logOut';
var localCard = 'localCard';
var maestro = 'maestro';
var machineLearning = 'machineLearning';
var masterCard = 'masterCard';
var master_card = 'master_card';
var magicHand = 'magicHand';
var moduleInfinity = 'moduleInfinity';
var moduleLightning = 'moduleLightning';
var moduleCertificate = 'moduleCertificate';
var moduleStar = 'moduleStar';
var offerHeader = 'offerHeader';
var payPal = 'payPal';
var noAds = 'noAds';
var paywallTimeline1 = 'paywallTimeline1';
var origami = 'origami';
var paywallTimeline2 = 'paywallTimeline2';
var paywallTimeline3 = 'paywallTimeline3';
var php = 'php';
var onboardingPsychoPro = 'onboardingPsychoPro';
var playMarket = 'playMarket';
var playStoreBadge = 'playStoreBadge';
var playfulOrangeGlasses = 'playfulOrangeGlasses';
var practiceCode = 'practiceCode';
var playfulOrange = 'playfulOrange';
var plusGradient = 'plusGradient';
var practiceWithAI = 'practiceWithAI';
var prioritySupport = 'prioritySupport';
var proAnnualPig = 'proAnnualPig';
var proAccessKey = 'proAccessKey';
var proBannerDesktopOrange = 'proBannerDesktopOrange';
var proBannerDesktopV2 = 'proBannerDesktopV2';
var proBannerMobileOrange = 'proBannerMobileOrange';
var proBannerMobileV2 = 'proBannerMobileV2';
var proBannerDesktop = 'proBannerDesktop';
var proBannerMobile = 'proBannerMobile';
var proGold = 'proGold';
var proGoldBlack = 'proGoldBlack';
var proGoldBlackV2 = 'proGoldBlackV2';
var profile = 'profile';
var proSave = 'proSave';
var proMonthlyCalendar = 'proMonthlyCalendar';
var purpleSolik = 'purpleSolik';
var pythonBeginners = 'pythonBeginners';
var python = 'python';
var pythonIntermadiate = 'pythonIntermadiate';
var pythonDataStructures = 'pythonDataStructures';
var quizUnlock = 'quizUnlock';
var quizHint = 'quizHint';
var refresh = 'refresh';
var react = 'react';
var ruby = 'ruby';
var reviewBackground = 'reviewBackground';
var sadFaceIllustration = 'sadFaceIllustration';
var rupr = 'rupr';
var sadSolikWithPhone = 'sadSolikWithPhone';
var sadSolik = 'sadSolik';
var settings = 'settings';
var search = 'search';
var purpleDots = 'purpleDots';
var solikWithPhone = 'solikWithPhone';
var solikHandWave = 'solikHandWave';
var smartYellow = 'smartYellow';
var sololearn = 'sololearn';
var spearLeft = 'spearLeft';
var spearRight = 'spearRight';
var sql = 'sql';
var sololearnPro = 'sololearnPro';
var stackoverflow = 'stackoverflow';
var starPro = 'starPro';
var statsGradient = 'statsGradient';
var stayCompetitive = 'stayCompetitive';
var successIllustration = 'successIllustration';
var swift = 'swift';
var targetColored = 'targetColored';
var understandData = 'understandData';
var unionpay = 'unionpay';
var unleashCreativity = 'unleashCreativity';
var unlockPractice = 'unlockPractice';
var upgradeToPro = 'upgradeToPro';
var upgradeToProV2 = 'upgradeToProV2';
var visa = 'visa';
var visaCard = 'visaCard';
var whiteStar = 'whiteStar';
var wrongRoundGrey = 'wrongRoundGrey';
var addEmoji = 'addEmoji';
var addSign = 'addSign';
var angleLabel = 'angleLabel';
var apple = 'apple';
var appleAward = 'appleAward';
var arrow = 'arrow';
var arrowRightDashed = 'arrowRightDashed';
var arrowRightSolid = 'arrowRightSolid';
var arrowRightSolidLong = 'arrowRightSolidLong';
var avatar = 'avatar';
var avatarFill = 'avatarFill';
var backArrow = 'backArrow';
var backLeftMonochrome = 'backLeftMonochrome';
var bgIllustration = 'bgIllustration';
var bgIllustrationMobile = 'bgIllustrationMobile';
var burger = 'burger';
var calendar = 'calendar';
var caretDown = 'caretDown';
var check = 'check';
var checkV2 = 'checkV2';
var checkmarkFilled = 'checkmarkFilled';
var circleDown = 'circleDown';
var circleSuccess = 'circleSuccess';
var clock = 'clock';
var close = 'close';
var closeV2 = 'closeV2';
var comments = 'comments';
var congratsActivity = 'congratsActivity';
var startPrompt = 'startPrompt';
var congratsCreatorTip = 'congratsCreatorTip';
var congratsLearnersNearby = 'congratsLearnersNearby';
var sololearnRound = 'sololearnRound';
var congratsMorePractice = 'congratsMorePractice';
var congratsViews = 'congratsViews';
var correctRound = 'correctRound';
var congratsLearningGoals = 'congratsLearningGoals';
var dashedArrow = 'dashedArrow';
var crown = 'crown';
var doubleArrow = 'doubleArrow';
var deleteIcon = 'deleteIcon';
var exclamationRounded = 'exclamationRounded';
var doubleQuotes = 'doubleQuotes';
var facebook = 'facebook';
var exclamationRoundedFill = 'exclamationRoundedFill';
var githubMono = 'githubMono';
var homeSparkleV1 = 'homeSparkleV1';
var heart = 'heart';
var google = 'google';
var homeSparkleV2 = 'homeSparkleV2';
var insertAttach = 'insertAttach';
var facebookPrimary = 'facebookPrimary';
var letter = 'letter';
var instagram = 'instagram';
var insertCode = 'insertCode';
var lightning = 'lightning';
var link = 'link';
var lock = 'lock';
var linkedinPrimary = 'linkedinPrimary';
var messageBubble = 'messageBubble';
var lockedLight = 'lockedLight';
var modalBackground1 = 'modalBackground1';
var modalBackground2 = 'modalBackground2';
var modalBackground3 = 'modalBackground3';
var linkedinMono = 'linkedinMono';
var move = 'move';
var notification = 'notification';
var oldHeart = 'oldHeart';
var pencil = 'pencil';
var play = 'play';
var playFilled = 'playFilled';
var reactionPositive = 'reactionPositive';
var reactionNegative = 'reactionNegative';
var simpleStar = 'simpleStar';
var sololearnMono = 'sololearnMono';
var sparkleBigRandom = 'sparkleBigRandom';
var sparkleLarge = 'sparkleLarge';
var sparkleMedium = 'sparkleMedium';
var sparkleSmall = 'sparkleSmall';
var sparkleSmallStars = 'sparkleSmallStars';
var sololearnRoundMono = 'sololearnRoundMono';
var stackoverflowMono = 'stackoverflowMono';
var sparkleV2 = 'sparkleV2';
var run = 'run';
var stars = 'stars';
var tag = 'tag';
var target = 'target';
var threeDots = 'threeDots';
var thunderFilled = 'thunderFilled';
var star = 'star';
var time = 'time';
var twitter = 'twitter';
var upload = 'upload';
var wrongRound = 'wrongRound';
var youtubePrimary = 'youtubePrimary';
var twitterPrimary = 'twitterPrimary';
var infiniteHeart = 'infiniteHeart';
var googlePlayEditorsChoice = 'googlePlayEditorsChoice';
var girlWithPhone = 'girlWithPhone';

export { addEmoji, addSign, adsFree, american_express, amexCard, angleLabel, angular, appStoreBadge, apple, appleAward, appleGenerativeAward, arrow, arrowRightDashed, arrowRightSolid, arrowRightSolidLong, attention, avatar, avatarFill, backArrow, backLeft, backLeftMonochrome, basicBlack, basicGrey, bgIllustration, bgIllustrationMobile, bit, bit1Cube, bit3Cubes, bitBordered, bitBought, bitCube, boostEfficiency, boyAndGirl, boyAndGirlV2, boyBoyGirl, boyEatsCookie, boyWithLaptop, brokenHeart, burger, c, cSharp2, calendar, calendarV2, caretDown, certificateV1Complete, certificateV1Incomplete, certificateV2Complete, certificateV2Incomplete, check, checkV2, checkmarkFilled, circleDown, circleDownGrey, circleSuccess, clock, close, closeV2, codeCheck, comments, congratsActivity, congratsCreatorTip, congratsLearnersNearby, congratsLearningGoals, congratsMorePractice, congratsViews, connectedAccountAvatar, correctRound, correctRoundBlue, cplusplus, cpp, crossPlatform, crown, csharp, css, dashedArrow, deleteIcon, diagram, discover, discoverCard, doubleArrow, doubleQuotes, dsPython, earnXp, edTech, educationalBlue, educationalBlueBoxer, elo, energeticMagenta, envelopIllustration, eom, errorIllustration, exclamationRounded, exclamationRoundedFill, facebook, facebookPrimary, fbCircle, fire, flag, flagOrange, girlWithLaptop, girlWithLaptopV2, girlWithPhone, github, githubMono, google, googlePlayEditorsChoice, growingGreen, growingGreenHero, heart, help, homeSparkleV1, homeSparkleV2, html, infiniteHeart, infiniteHearts, infinity, infinityV2, infinityV3, infinityV4, info, innovativePurple, innovativePurplePuzzle, insertAttach, insertCode, instagram, instagramPrimary, intergalactic, java, jcb, jcbCard, jquery, js, kotlin, leaderboardOnboarding, letter, lightning, link, linkedin, linkedinMono, linkedinPrimary, localCard, lock, lockedLight, logOut, machineLearning, maestro, magicHand, masterCard, master_card, messageBubble, modalBackground1, modalBackground2, modalBackground3, moduleCertificate, moduleInfinity, moduleLightning, moduleStar, move, noAds, notification, offerHeader, oldHeart, onboardingPsychoPro, origami, payPal, paywallTimeline1, paywallTimeline2, paywallTimeline3, pencil, php, play, playFilled, playMarket, playStoreBadge, playfulOrange, playfulOrangeGlasses, plusGradient, practiceCode, practiceWithAI, prioritySupport, proAccessKey, proAnnualPig, proBannerDesktop, proBannerDesktopOrange, proBannerDesktopV2, proBannerMobile, proBannerMobileOrange, proBannerMobileV2, proGold, proGoldBlack, proGoldBlackV2, proMonthlyCalendar, proSave, profile, purpleDots, purpleSolik, python, pythonBeginners, pythonDataStructures, pythonIntermadiate, quizHint, quizUnlock, react, reactionNegative, reactionPositive, refresh, reviewBackground, ruby, run, rupr, sadFaceIllustration, sadSolik, sadSolikWithPhone, search, settings, simpleStar, smartYellow, solikHandWave, solikWithPhone, sololearn, sololearnMono, sololearnPro, sololearnRound, sololearnRoundMono, sparkleBigRandom, sparkleLarge, sparkleMedium, sparkleSmall, sparkleSmallStars, sparkleV2, spearLeft, spearRight, sql, stackoverflow, stackoverflowMono, star, starPro, stars, startPrompt, statsGradient, stayCompetitive, successIllustration, swift, tag, target, targetColored, threeDots, thunderFilled, time, twitter, twitterPrimary, understandData, unionpay, unleashCreativity, unlockPractice, upgradeToPro, upgradeToProV2, upload, visa, visaCard, whiteStar, wrongRound, wrongRoundGrey, youtubePrimary };
